import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class ClaimController extends Controller {
  @service store;
  @service router;
  @service currentUser;
  adapter = this.store.adapterFor('person');

  @action
  async claimUser(id) {
    await this.adapter.claimUser(id);
    window.location.href = '/';
  }

  @action
  async createNewUser() {
    let newUser = await this.currentUser.createUser();
    await this.currentUser.claimUser(newUser.id);
    window.location.href = '/';
  }

  get unclaimedPersons() {
    return this.model.filter((person) => {
      return person.is_claimed === false;
    });
  }
}
